import { useStoreData } from '../contexts/StoreDataContext';

/**
 * usePermissions Hook
 * Provides permission checking functionality for the current user in the current store
 * 
 * This hook now uses StoreDataContext for cached permissions - NO API calls!
 * Permissions are loaded once when the store is selected and cached globally.
 */
export const usePermissions = () => {
  // Use the global StoreDataContext - no individual API calls!
  const {
    permissions,
    permissionsLoading: loading,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isAdmin,
    isOwner
  } = useStoreData();

  return {
    permissions,
    loading,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    isAdmin,
    isOwner
  };
};
